import instance from "./request";

// 请求用户充值返利信息(新手奖励专属活动)
export function getChargeRebateInfo(value:any) {
    return instance.post('/v4/bus/getChargeRebateInfo', value);
}

// 领取返现奖励
export function receiveReBateReward(value:any) {
    return instance.post('/v4/bus/receiveReBateReward', value);
}

// 邀请奖励统计
export function statInvitePaidUserReward(value:any) {
    return instance.post('/v4/bus/statInvitePaidUserReward', value);
}

// 领取邀请奖励
export function receiveInvitePaidUserReward(value:any) {
    return instance.post('/v4/bus/receiveInvitePaidUserReward', value);
}

// 获取邀请用户明细
export function getInviteDetails(value:any) {
    return instance.post('/v4/bus/getInviteDetails', value);
}

// 获取代理奖励配置
export function getWeb4AgentRewardConfigs(value:any) {
    return instance.post('/v4/bus/getWeb4AgentRewardConfigs', value);
}

// 代理数据汇总
export function statMyWeb4AgentReward(value:any) {
    return instance.post('/v4/bus/statMyWeb4AgentReward', value);
}

// 代理数据明细
export function getMyWeb4AgentRewardDetail(value:any) {
    return instance.post('/v4/bus/getMyWeb4AgentRewardDetail', value);
}

// 领取代理活动奖励
export function receiveWeb4AgentReward(value:any) {
    return instance.post('/v4/bus/receiveWeb4AgentReward', value);
}

// 下注返还活动数据汇总
export function statBetReward(value:any) {
    return instance.post('/v4/bus/statBetReward', value);
}

// 下注返还活动奖励领取
export function receiveBetReward(value:any) {
    return instance.post('/v4/bus/receiveBetReward', value);
}

// 获取亏损返回数据
export function getWeb4LoseReturnInfo(value:any) {
    return instance.post('/v4/bus/getWeb4LoseReturnInfo', value);
}

// 领取亏损返还奖励
export function receiveWeb4LoseReturnReward(value:any) {
    return instance.post('/v4/bus/receiveWeb4LoseReturnReward', value);
}

// 获取用户vip信息
export function getUserVipInfo(value:any) {
    return instance.post('/v4/bus/getUserVipInfo', value);
}

//查询账户信息
export function accountInfo(value:any) {
    return instance.post('/v4/bus/accountInfo',value);
}

//查询账户信息
export function withdrawInfo(value:any) {
    return instance.post('/v4/bus/withdrawInfo',value);
}

//领取转盘奖励
export function receiveNewUserReward(value:any) {
    return instance.post('/v4/bus/receiveNewUserReward',value);
}